import { axiosInstance as request } from '@api/rest.service'

const api = '/meta-data-values'

/**
 * @description GET /meta-data-values/{entity}/{entityId}
 * @returns {AxiosPromise<any>}
 */
export const GET_METADATA_VALUES_FOR_ENTITY = (entity, entityId) => request.get(`${api}/${entity}/${entityId}`)

/**
 * @description PUT /meta-data-values/{id}/{entity}/{entityId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_METADATA_VALUE_FOR_ENTITY = (id, payload, entity, entityId) =>
  request.put(`${api}/${id}/${entity}/${entityId}`, payload)
